"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "next-themes";
import { SettingsProvider } from "@/lib/settings-context";
import { PremiumTooltipProvider } from "@/components/ui/premium-tooltip";
import { RegionalProvider } from "@/contexts/RegionalContext";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
        <RegionalProvider>
          <SettingsProvider>
            <PremiumTooltipProvider>
              {children}
            </PremiumTooltipProvider>
          </SettingsProvider>
        </RegionalProvider>
      </ThemeProvider>
    </SessionProvider>
  );
}
